import type { SttProvider } from '@ai-meeting/shared'
import type { UiStrings } from '@/constants/ui-locale'

/**
 * Maps a persisted `sttProvider` value to its human-readable display name,
 * reusing the same locale strings shown in the create-meeting provider picker
 * so the Admin table and Meeting Detail page stay consistent with it.
 */
export function getSttProviderLabel(provider: SttProvider, t: UiStrings): string {
  if (provider === 'azure') return t.sttProviderAzureLabel
  if (provider === 'google_live_translate') return t.sttProviderGoogleLabel
  if (provider === 'gpt-realtime-whisper') return t.sttProviderChatgptLabel
  return t.sttProviderSonioxLabel
}
